/* global google */
import { _, debug } from '../utils'

export default class Map {
    constructor(el) {
        this.el = el
        this.lat = parseFloat(this.el.dataset.lat)
        this.lng = parseFloat(this.el.dataset.lng)
        if (typeof google === 'undefined') {
            if (debug) {
                console.warn('missing google for maps')
            }
            return false
        }
        this.map = new google.maps.Map(this.el, {
            center: { lat: this.lat, lng: this.lng },
            zoom: 8,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false
        })
        this.marker = new google.maps.Marker({
            position: new google.maps.LatLng(this.lat, this.lng),
            icon:
                '/application/themes_parent/app/images/interface/location@1x.svg',
            map: this.map
        })
    }
}
